import React, { useEffect } from 'react';
import { resolveTheme, applyThemeToDocument } from '../themes';

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    const theme = resolveTheme();
    applyThemeToDocument(theme);
  }, []);

  return <>{children}</>;
};

export default ThemeProvider;
